<template>
    <div style="overflow: hidden;height: 140px;">
  <div ref="containerDiv" class="time-component">
    <div class="canvas-container">
      <canvas ref="myCanvas" :width="canvasSize" :height="canvasSize"
        class="time-canvas"
      ></canvas>
    </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    // 容器宽度，可以从外部传入
    width: {
      type: Number,
      default: 350
    }
  },
  emits: [
    'time-data-change', // 时间数据变化事件
    'timer-state-change', // 定时器状态变化事件
  ],
  data() {
    return {
      // 响应式尺寸属性
      containerWidth: this.width, // 容器宽度，从props获取

      // 动态计算的尺寸属性（将在computed中计算）
      center: { x: 195, y: 195 },
      radius: 150,

      pointerAngle: -Math.PI / 2,
      baseStart: Math.PI * 1.1,
      baseEnd: Math.PI * 1.9,

      // 红色数据弧线属性
      dataArcLength: Math.PI * 1.5, // 数据弧线总长度（270度）
      dataSegments: 0, // 数据段数，将根据list长度动态设置
      dataStartAngle: -Math.PI / 2, // 初始位置在黑色指针位置（正上方）
      dataValues: [], // 存储数据值
      isDraggingDataArc: false,
      dataArcDragOffset: 0,
      list: [],

      // 定时器相关属性
      timer: null, // 定时器实例
      isTimerRunning: false, // 定时器运行状态
      isTimerPausedByDrag: false, // 是否因为拖拽而暂停定时器
      wasTimerRunningBeforeDrag: false, // 拖拽前定时器是否在运行
      currentTimeIndex: 0, // 当前时间索引
      timeIntervals: [], // 时间间隔数组
      jumpToIndex: 0 // 手动跳转的目标索引
    }
  },
  computed: {
    // 响应式尺寸计算
    canvasSize() {
      return this.containerWidth * 1.11; // canvas比容器稍大一点，留出边距
    },
    scaleFactor() {
      return this.containerWidth / 350; // 基于350px的缩放比例
    },
    responsiveCenter() {
      const size = this.canvasSize;
      return { x: size / 2, y: size / 2 };
    },
    responsiveRadius() {
      return 150 * this.scaleFactor;
    },
    // 响应式线宽
    baseArcLineWidth() {
      return Math.max(20, 40 * this.scaleFactor); // 底色弧线宽度，最小20px
    },
    dataArcLineWidth() {
      return Math.max(5, 10 * this.scaleFactor); // 数据弧线宽度，最小5px
    },
    pointerLineWidth() {
      return Math.max(2, 4 * this.scaleFactor); // 指针线宽，最小2px
    },
    scaleLineWidth() {
      return Math.max(1, 2 * this.scaleFactor); // 刻度线宽，最小1px
    },
    pointerLength() {
      return 30 * this.scaleFactor; // 指针长度
    },

    // 数据弧线的结束角度
    dataEndAngle() {
      return this.dataStartAngle + this.dataArcLength;
    },
    // 每个数据段的角度大小
    segmentAngle() {
      // 当dataSegments为0时，返回0避免除零错误
      return this.dataSegments > 0 ? this.dataArcLength / this.dataSegments : 0;
    },
    // 获取当前时间索引对应的数据
    currentTimeData() {
      if (this.currentTimeIndex >= 0 && this.currentTimeIndex < this.list.length) {
        return this.list[this.currentTimeIndex];
      }
      return null;
    },
    // 计算黑色指针位置对应的数据值 - 与定时器控制同步
    currentPointerValue() {
      // 使用与定时器控制相同的数据源，确保信息同步
      if (this.currentTimeData) {
        // 计算当前时间索引对应的数据段索引
        const segmentIndex = this.currentTimeIndex;

        // 状态到颜色的映射
        const statusColorMap = {
          'running': 'red',      // 跑 - 红色
          'sitting': 'yellow',   // 坐 - 黄色
          'standing': 'green',   // 站立 - 绿色
          'walking': 'purple',   // 行走 - 紫色
          'lying': 'blue',       // 爬 - 蓝色
          'eatting': 'gray'      // 吃 - 灰色
        };

        return {
          index: segmentIndex + 1, // 显示从1开始的索引
          value: '50.00', // 固定值，与dataValues中的值保持一致
          colorType: statusColorMap[this.currentTimeData.attitude] || 'red',
          status: this.currentTimeData.attitude,
          receivedTime: this.currentTimeData.receivedTime,
          angle: (this.pointerAngle * 180 / Math.PI).toFixed(1) + '°'
        };
      } else if (this.list && this.list.length > 0 && this.dataValues.length > 0) {
        // 如果currentTimeData为空但有数据，使用第一个数据项
        const firstItem = this.list[0];
        const firstDataValue = this.dataValues[0];

        return {
          index: 1, // 显示从1开始的索引
          value: '50.00', // 固定值
          colorType: firstDataValue.colorType,
          status: firstItem.attitude,
          receivedTime: firstItem.receivedTime,
          angle: (this.pointerAngle * 180 / Math.PI).toFixed(1) + '°'
        };
      }

      return null;
    }
  },
  watch: {
    // 监听width props的变化
    width(newWidth) {
      this.containerWidth = newWidth;
      this.initializeResponsiveSizes();
      this.drawArc();
    }
  },
  mounted() {
    console.log('=== 组件挂载开始 ===');
    console.log('list数据:', this.list);
    console.log('list长度:', this.list ? this.list.length : 'undefined');
    console.log('list前5项:', this.list ? this.list.slice(0, 5) : 'undefined');

    // 初始化响应式尺寸
    // this.initializeResponsiveSizes();
    // this.initializeDataValues();
    // this.initializeTimer();
    // this.drawArc();
    const canvas = this.$refs.myCanvas;
    canvas.addEventListener('touchstart', this.onTouchStart, { passive: false });
    canvas.addEventListener('touchmove', this.onTouchMove, { passive: false });
    canvas.addEventListener('touchend', this.onTouchEnd, { passive: false });

    // 添加鼠标事件支持（用于桌面端测试）
    canvas.addEventListener('mousedown', this.onMouseDown, { passive: false });
    canvas.addEventListener('mousemove', this.onMouseMove, { passive: false });
    canvas.addEventListener('mouseup', this.onMouseUp, { passive: false });
    canvas.addEventListener('mouseleave', this.onMouseUp, { passive: false });

    // 监听窗口大小变化
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy() {
    // 清理定时器
    this.stopTimer();

    const canvas = this.$refs.myCanvas;
    canvas.removeEventListener('touchstart', this.onTouchStart);
    canvas.removeEventListener('touchmove', this.onTouchMove);
    canvas.removeEventListener('touchend', this.onTouchEnd);
    canvas.removeEventListener('mousedown', this.onMouseDown);
    canvas.removeEventListener('mousemove', this.onMouseMove);
    canvas.removeEventListener('mouseup', this.onMouseUp);
    canvas.removeEventListener('mouseleave', this.onMouseUp);

    // 清理窗口事件监听
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    // 向父组件发送当前时间数据
    emitTimeDataToParent() {
      const timeData = {
        currentTime: this.currentTimeData ? this.currentTimeData.receivedTime : null,
        currentStatus: this.currentTimeData ? this.currentTimeData.attitude : null,
        currentIndex: this.currentTimeIndex,
        totalSegments: this.dataSegments,
        isTimerRunning: this.isTimerRunning,
        isTimerPausedByDrag: this.isTimerPausedByDrag,
        timerState: this.isTimerRunning ? (this.isTimerPausedByDrag ? '暂停中(拖拽)' : '运行中') : '已停止',
        pointerValue: this.currentPointerValue,
        nextInterval: this.timeIntervals.length > 0 && this.currentTimeIndex < this.timeIntervals.length
          ? this.timeIntervals[this.currentTimeIndex]
          : null
      };

      // 发送时间数据变化事件
      this.$emit('time-data-change', timeData);
    },

    // 向父组件发送定时器状态变化
    emitTimerStateToParent() {
      const timerState = {
        isRunning: this.isTimerRunning,
        isPausedByDrag: this.isTimerPausedByDrag,
        currentIndex: this.currentTimeIndex,
        totalSegments: this.dataSegments,
        state: this.isTimerRunning ? (this.isTimerPausedByDrag ? '暂停中(拖拽)' : '运行中') : '已停止'
      };

      // 发送定时器状态变化事件
      this.$emit('timer-state-change', timerState);
    },

    getListInit(newList) {
      this.list = newList
      this.initializeResponsiveSizes();
      this.initializeDataValues();
      this.initializeTimer();
      this.drawArc();
      this.startTimer()

      // 初始化完成后发送初始数据给父组件
      this.$nextTick(() => {
        this.emitTimeDataToParent();
      });
    },
    // 初始化响应式尺寸
    initializeResponsiveSizes() {
      // 更新中心点和半径
      this.center = this.responsiveCenter;
      this.radius = this.responsiveRadius;
    },

    // 处理窗口大小变化
    handleResize() {
      // 可以根据需要调整容器宽度
      // 这里保持固定宽度，如果需要响应式可以修改
      this.initializeResponsiveSizes();
      this.drawArc();
    },



    // 初始化定时器相关数据
    initializeTimer() {
      console.log('初始化定时器数据');

      if (!this.list || this.list.length === 0) {
        console.error('无法初始化定时器：list数据为空');
        return;
      }

      // 解析时间并计算时间间隔
      this.timeIntervals = [];
      let previousTime = null;

      // 由于数据是按时间倒序排列的，我们需要从后往前处理
      for (let i = this.list.length - 1; i >= 0; i--) {
        const currentTime = new Date(this.list[i].receivedTime);

        if (previousTime) {
          // 计算与前一个时间的间隔（秒）
          const intervalSeconds = Math.abs((currentTime - previousTime) / 1000);
          // 如果间隔太小（小于0.5秒）或太大（大于60秒），使用默认值1秒
          const normalizedInterval = (intervalSeconds < 0.5 || intervalSeconds > 60) ? 1 : intervalSeconds;
          this.timeIntervals.push(normalizedInterval);
        } else {
          // 第一个数据点，默认间隔1秒
          this.timeIntervals.push(1);
        }

        previousTime = currentTime;
      }

      // 反转时间间隔数组，使其与数据顺序一致
      this.timeIntervals.reverse();
    },

    // 启动定时器
    startTimer() {
      if (this.isTimerRunning) {
        console.log('定时器已在运行');
        return;
      }

      console.log('启动定时器');
      this.isTimerRunning = true;
      this.emitTimerStateToParent(); // 发送定时器状态变化
      this.runTimerStep();
    },

    // 停止定时器
    stopTimer() {
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }
      this.isTimerRunning = false;
      this.emitTimerStateToParent(); // 发送定时器状态变化
      console.log('定时器已停止');
    },

    // 重置定时器
    resetTimer() {
      this.stopTimer();
      this.currentTimeIndex = 0;
      this.jumpToIndex = 0;
      // 重置拖拽暂停状态
      this.isTimerPausedByDrag = false;
      this.wasTimerRunningBeforeDrag = false;
      // 重置数据弧线到初始位置（时间索引0对应的位置）
      this.slideDataArcToTimeIndex(0);
      this.emitTimeDataToParent(); // 发送时间数据变化
      console.log('定时器已重置到初始位置');
    },

    // 因拖拽暂停定时器
    pauseTimerForDrag() {
      if (this.isTimerRunning && !this.isTimerPausedByDrag) {
        this.wasTimerRunningBeforeDrag = true;
        this.isTimerPausedByDrag = true;
        this.emitTimerStateToParent(); // 发送定时器状态变化
        console.log('定时器因拖拽暂停');
      }
    },

    // 拖拽结束后恢复定时器
    resumeTimerAfterDrag() {
      if (this.wasTimerRunningBeforeDrag && this.isTimerPausedByDrag) {
        this.isTimerPausedByDrag = false;
        this.wasTimerRunningBeforeDrag = false;
        this.emitTimerStateToParent(); // 发送定时器状态变化
        console.log('拖拽结束，定时器恢复运行');
      }
    },

    // 手动跳转到指定时间索引
    jumpToTimeIndex() {
      if (this.jumpToIndex < 0 || this.jumpToIndex >= this.dataSegments) {
        console.warn('跳转索引超出范围:', this.jumpToIndex);
        return;
      }

      // 停止当前定时器
      this.stopTimer();

      // 设置当前时间索引
      this.currentTimeIndex = this.jumpToIndex;

      // 滑动数据弧线到指定位置
      this.slideDataArcToTimeIndex(this.jumpToIndex);

      // 发送索引变化和时间数据变化
      this.emitTimeDataToParent();

      console.log(`手动跳转到时间索引: ${this.jumpToIndex + 1}/${this.dataSegments}`);
    },

    // 执行定时器步骤
    runTimerStep() {
      if (!this.isTimerRunning || this.currentTimeIndex >= this.dataSegments) {
        this.stopTimer();
        console.log('定时器执行完毕');
        return;
      }

      // 如果因为拖拽而暂停，跳过这次执行但保持定时器运行状态
      if (this.isTimerPausedByDrag) {
        console.log('定时器因拖拽暂停，等待恢复...');
        // 设置较短的检查间隔，等待拖拽结束
        this.timer = setTimeout(() => {
          this.runTimerStep();
        }, 100);
        return;
      }

      // 计算当前时间间隔（使用实际时间间隔或默认1秒）
      const currentInterval = this.timeIntervals[this.currentTimeIndex] || 1;
      // 将时间间隔限制在合理范围内：最小0.5秒，最大3秒
      const intervalMs = Math.max(500, Math.min(currentInterval * 1000, 3000));

      console.log(`定时器步骤 ${this.currentTimeIndex + 1}/${this.dataSegments}, 间隔: ${(intervalMs/1000).toFixed(1)}秒`);

      // 滑动数据弧线到当前时间索引对应的位置
      this.slideDataArcToTimeIndex(this.currentTimeIndex);

      // 发送时间数据变化
      this.emitTimeDataToParent();

      // 移动到下一个时间索引
      this.currentTimeIndex++;

      // 设置下一次执行
      this.timer = setTimeout(() => {
        this.runTimerStep();
      }, intervalMs);
    },

    // 滑动数据弧线到指定的时间索引位置
    slideDataArcToTimeIndex(timeIndex) {
      // 计算每个数据段的角度
      const segmentAngle = this.segmentAngle;

      // 计算目标位置：从初始位置（-π/2）开始，向逆时针方向移动 timeIndex 个段的角度
      const initialStartAngle = -Math.PI / 2; // 初始位置在黑色指针位置（正上方）
      const targetStartAngle = initialStartAngle - (timeIndex * segmentAngle);

      // 标准化角度到 [-π, π] 范围
      const normalizeToRange = (angle) => {
        while (angle > Math.PI) angle -= 2 * Math.PI;
        while (angle <= -Math.PI) angle += 2 * Math.PI;
        return angle;
      };

      let normalizedTargetAngle = normalizeToRange(targetStartAngle);

      // 检查滑动限制
      const pointerPosition = this.pointerAngle; // -Math.PI / 2
      const minDataStart = pointerPosition - this.dataArcLength;
      const maxDataStart = pointerPosition;
      const normalizedMin = normalizeToRange(minDataStart);
      const normalizedMax = normalizeToRange(maxDataStart);

      // 应用滑动限制
      if (normalizedMin <= normalizedMax) {
        // 正常情况，不跨越-π/π边界
        if (normalizedTargetAngle < normalizedMin) {
          normalizedTargetAngle = normalizedMin;
          console.log('达到左滑动限制，停止在限制位置');
        }
        if (normalizedTargetAngle > normalizedMax) {
          normalizedTargetAngle = normalizedMax;
          console.log('达到右滑动限制，停止在限制位置');
        }
      } else {
        // 跨越-π/π边界的情况
        if (normalizedTargetAngle > normalizedMax && normalizedTargetAngle < normalizedMin) {
          // 在禁止区域内，选择最近的边界
          const distToMax = Math.abs(normalizedTargetAngle - normalizedMax);
          const distToMin = Math.abs(normalizedTargetAngle - normalizedMin);
          if (distToMax < distToMin) {
            normalizedTargetAngle = normalizedMax;
            console.log('达到右滑动限制（跨边界）');
          } else {
            normalizedTargetAngle = normalizedMin;
            console.log('达到左滑动限制（跨边界）');
          }
        }
      }

      // 设置数据弧线的新起始位置
      this.dataStartAngle = normalizedTargetAngle;

      // 重新绘制
      this.drawArc();
    },

    // 根据数据弧线位置更新当前时间索引，实现数据同步
    updateCurrentTimeIndexFromDataArc() {
      // 黑色指针的角度（正上方，-π/2）
      const pointerAngle = this.pointerAngle;

      // 计算指针相对于数据弧线起始位置的角度差
      let angleDiff = pointerAngle - this.dataStartAngle;

      // 标准化角度差到 [0, 2π] 范围
      while (angleDiff < 0) angleDiff += Math.PI * 2;
      while (angleDiff >= Math.PI * 2) angleDiff -= Math.PI * 2;

      // 如果指针不在数据弧线范围内，不更新时间索引
      if (angleDiff > this.dataArcLength) {
        return;
      }

      // 计算对应的数据段索引
      const segmentIndex = Math.floor(angleDiff / this.segmentAngle);

      // 确保索引在有效范围内，并更新当前时间索引
      if (segmentIndex >= 0 && segmentIndex < this.dataSegments) {
        this.currentTimeIndex = segmentIndex;
        this.jumpToIndex = segmentIndex; // 同步更新跳转输入框的值

        // 发送索引变化和时间数据变化
        this.emitTimeDataToParent();
      }
    },

    // 初始化数据值
    initializeDataValues() {
      console.log('开始初始化数据，list长度:', this.list ? this.list.length : 'list为空');

      if (!this.list || this.list.length === 0) {
        console.log('list数据为空，重置数据相关属性');
        this.dataValues = [];
        this.dataSegments = 0;
        return;
      }

      // 使用list中的数据
      this.dataValues = [];
      this.dataSegments = this.list.length; // 根据实际数据长度设置段数

      console.log('设置数据段数为:', this.dataSegments);

      // 状态到颜色的映射
      const statusColorMap = {
        'running': 'red',      // 跑 - 红色
        'sitting': 'yellow',   // 坐 - 黄色
        'standing': 'green',   // 站立 - 绿色
        'walking': 'purple',   // 行走 - 紫色
        'lying': 'blue',       // 爬 - 蓝色
        'eatting': 'gray'      // 吃 - 灰色
      };

      for (let i = 0; i < this.list.length; i++) {
        const item = this.list[i];
        const attitude = item.attitude || 'running'; // 使用attitude字段作为状态
        const colorType = statusColorMap[attitude] || 'red'; // 默认红色

        this.dataValues.push({
          value: 50, // 固定值，用于透明度计算
          colorType: colorType,
          status: attitude,
          receivedTime: item.receivedTime || '', // 保存接收时间
          originalData: item // 保存原始数据
        });
      }

      console.log('初始化数据完成，总段数:', this.dataSegments);
      console.log('数据样例:', this.dataValues.slice(0, 5));
      console.log('segmentAngle:', this.segmentAngle);
    },

    getTouchPos(e) {
      const rect = this.$refs.myCanvas.getBoundingClientRect();
      const touch = e.touches[0];
      return {
        x: touch.clientX - rect.left,
        y: touch.clientY - rect.top
      };
    },
    normalizeAngle(angle) {
      while (angle < 0) angle += Math.PI * 2;
      while (angle >= Math.PI * 2) angle -= Math.PI * 2;
      return angle;
    },
    angleFromCenter(pos) {
      return this.normalizeAngle(Math.atan2(pos.y - this.center.y, pos.x - this.center.x));
    },
    onTouchStart(e) {
      e.preventDefault();
      const pos = this.getTouchPos(e);
      const angle = this.angleFromCenter(pos);

      // 检查是否点击在数据弧线附近
      if (this.isNearDataArc(angle)) {
        this.isDraggingDataArc = true;
        this.dataArcDragOffset = angle - this.dataStartAngle;
        // 暂停定时器
        this.pauseTimerForDrag();
      } else {
        this.isDraggingDataArc = false;
      }
    },
    onTouchMove(e) {
      if (!this.isDraggingDataArc) return;
      e.preventDefault();
      const pos = this.getTouchPos(e);
      let angle = this.angleFromCenter(pos);
        // 处理数据弧线拖拽
        let newDataStart = angle - this.dataArcDragOffset;

        // 黑色指针的位置
        const pointerPosition = this.pointerAngle; // -Math.PI / 2

        // 计算滑动限制：
        // 1. 向右滑动限制：数据弧线起始位置不能超过指针位置
        const maxDataStart = pointerPosition;

        // 2. 向左滑动限制：数据弧线末尾位置不能超过指针位置
        // 当数据弧线末尾与指针重叠时：newDataStart + dataArcLength = pointerPosition
        // 所以：newDataStart = pointerPosition - dataArcLength
        const minDataStart = pointerPosition - this.dataArcLength;

        // 标准化角度到 [-π, π] 范围，避免跳转问题
        const normalizeToRange = (angle) => {
          while (angle > Math.PI) angle -= 2 * Math.PI;
          while (angle <= -Math.PI) angle += 2 * Math.PI;
          return angle;
        };

        newDataStart = normalizeToRange(newDataStart);
        const normalizedMin = normalizeToRange(minDataStart);
        const normalizedMax = normalizeToRange(maxDataStart);

        // 应用滑动限制，防止跳转
        if (normalizedMin <= normalizedMax) {
          // 正常情况，不跨越-π/π边界
          if (newDataStart < normalizedMin) {
            newDataStart = normalizedMin;
            console.log('达到左滑动限制：数据弧线末尾与指针重叠');
          }
          if (newDataStart > normalizedMax) {
            newDataStart = normalizedMax;
            console.log('达到右滑动限制：数据弧线起始位置与指针重叠');
          }
        } else {
          // 跨越-π/π边界的情况
          if (newDataStart > normalizedMax && newDataStart < normalizedMin) {
            // 在禁止区域内，选择最近的边界
            const distToMax = Math.abs(newDataStart - normalizedMax);
            const distToMin = Math.abs(newDataStart - normalizedMin);
            if (distToMax < distToMin) {
              newDataStart = normalizedMax;
              console.log('达到右滑动限制（跨边界）');
            } else {
              newDataStart = normalizedMin;
              console.log('达到左滑动限制（跨边界）');
            }
          }
        }

        this.dataStartAngle = newDataStart;

        // 计算当前指针位置对应的时间索引，实现数据同步
        this.updateCurrentTimeIndexFromDataArc();

      this.drawArc();
    },
    onTouchEnd() {
      // 如果正在拖拽数据弧线，恢复定时器
      if (this.isDraggingDataArc) {
        this.resumeTimerAfterDrag();
      }

      this.isDraggingDataArc = false;
    },

    // 检查点击位置是否在数据弧线附近
    isNearDataArc(angle) {
      const dataArcStart = this.normalizeAngle(this.dataStartAngle);
      const dataArcEnd = this.normalizeAngle(this.dataStartAngle + this.dataArcLength);
      const normalizedAngle = this.normalizeAngle(angle);

      // 计算到数据弧线的最短距离
      let distance = Math.min(
        Math.abs(normalizedAngle - dataArcStart),
        Math.abs(normalizedAngle - dataArcEnd)
      );

      // 处理跨越0度的情况
      if (dataArcStart <= dataArcEnd) {
        // 圆弧不跨越0度
        if (normalizedAngle >= dataArcStart && normalizedAngle <= dataArcEnd) {
          distance = 0; // 在圆弧内
        }
      } else {
        // 圆弧跨越0度
        if (normalizedAngle >= dataArcStart || normalizedAngle <= dataArcEnd) {
          distance = 0; // 在圆弧内
        }
      }

      // 0.3弧度（约17度）的容差
      return distance < 0.3;
    },



    // 鼠标事件处理（用于桌面端测试）
    getMousePos(e) {
      const rect = this.$refs.myCanvas.getBoundingClientRect();
      return {
        x: e.clientX - rect.left,
        y: e.clientY - rect.top
      };
    },

    onMouseDown(e) {
      e.preventDefault();
      const pos = this.getMousePos(e);
      const angle = this.angleFromCenter(pos);

      // 检查是否点击在数据弧线附近
      if (this.isNearDataArc(angle)) {
        this.isDraggingDataArc = true;
        this.dataArcDragOffset = angle - this.dataStartAngle;
        // 暂停定时器
        this.pauseTimerForDrag();
      } else {
        this.isDraggingDataArc = false;
      }
    },

    onMouseMove(e) {
      if (!this.isDraggingDataArc) return;
      e.preventDefault();
      const pos = this.getMousePos(e);
      let angle = this.angleFromCenter(pos);
        // 处理数据弧线拖拽
        let newDataStart = angle - this.dataArcDragOffset;

        // 黑色指针的位置
        const pointerPosition = this.pointerAngle; // -Math.PI / 2

        // 计算滑动限制：
        // 1. 向右滑动限制：数据弧线起始位置不能超过指针位置
        const maxDataStart = pointerPosition;

        // 2. 向左滑动限制：数据弧线末尾位置不能超过指针位置
        // 当数据弧线末尾与指针重叠时：newDataStart + dataArcLength = pointerPosition
        // 所以：newDataStart = pointerPosition - dataArcLength
        const minDataStart = pointerPosition - this.dataArcLength;

        // 标准化角度到 [-π, π] 范围，避免跳转问题
        const normalizeToRange = (angle) => {
          while (angle > Math.PI) angle -= 2 * Math.PI;
          while (angle <= -Math.PI) angle += 2 * Math.PI;
          return angle;
        };

        newDataStart = normalizeToRange(newDataStart);
        const normalizedMin = normalizeToRange(minDataStart);
        const normalizedMax = normalizeToRange(maxDataStart);

        // 应用滑动限制，防止跳转
        if (normalizedMin <= normalizedMax) {
          // 正常情况，不跨越-π/π边界
          if (newDataStart < normalizedMin) {
            newDataStart = normalizedMin;
            console.log('达到左滑动限制：数据弧线末尾与指针重叠');
          }
          if (newDataStart > normalizedMax) {
            newDataStart = normalizedMax;
            console.log('达到右滑动限制：数据弧线起始位置与指针重叠');
          }
        } else {
          // 跨越-π/π边界的情况
          if (newDataStart > normalizedMax && newDataStart < normalizedMin) {
            // 在禁止区域内，选择最近的边界
            const distToMax = Math.abs(newDataStart - normalizedMax);
            const distToMin = Math.abs(newDataStart - normalizedMin);
            if (distToMax < distToMin) {
              newDataStart = normalizedMax;
              console.log('达到右滑动限制（跨边界）');
            } else {
              newDataStart = normalizedMin;
              console.log('达到左滑动限制（跨边界）');
            }
          }
        }

        this.dataStartAngle = newDataStart;

        // 计算当前指针位置对应的时间索引，实现数据同步
        this.updateCurrentTimeIndexFromDataArc();

      this.drawArc();
    },

    onMouseUp() {
      // 如果正在拖拽数据弧线，恢复定时器
      if (this.isDraggingDataArc) {
        this.resumeTimerAfterDrag();
      }

      this.isDraggingDataArc = false;
    },
    drawArc() {
      const canvas = this.$refs.myCanvas;
      const ctx = canvas.getContext('2d');
      ctx.clearRect(0, 0, canvas.width, canvas.height);

      // 画底色弧 - 使用渐变和更现代的样式
      ctx.save();

      // 创建径向渐变
      const gradient = ctx.createLinearGradient(
        this.center.x - this.radius, this.center.y - this.radius,
        this.center.x + this.radius, this.center.y + this.radius
      );
      gradient.addColorStop(0, 'rgba(59, 130, 246, 0.1)'); // 主色调浅色
      gradient.addColorStop(0.5, 'rgba(59, 130, 246, 0.2)');
      gradient.addColorStop(1, 'rgba(59, 130, 246, 0.1)');

      ctx.beginPath();
      ctx.arc(this.center.x, this.center.y, this.radius, this.baseStart, this.baseEnd, false);
      ctx.strokeStyle = gradient;
      ctx.lineWidth = this.baseArcLineWidth;
      ctx.lineCap = 'round';
      ctx.stroke();

      // 添加内侧阴影效果
      ctx.beginPath();
      ctx.arc(this.center.x, this.center.y, this.radius - 2, this.baseStart, this.baseEnd, false);
      ctx.strokeStyle = 'rgba(59, 130, 246, 0.05)';
      ctx.lineWidth = Math.max(2, 4 * this.scaleFactor);
      ctx.stroke();

      ctx.restore();

      // 只有当list有数据时才画数据弧线
      if (this.list && this.list.length > 0) {
        // 画红色数据弧线（分割成7200段）
        this.drawDataArc(ctx);

        // 绘制时间刻度
        this.drawTimeScale(ctx);
      }

      // 画canvas正中间的定位指针 - 现代化设计
      ctx.save();

      // 指针主体 - 使用渐变
      const pointerGradient = ctx.createLinearGradient(
        this.center.x, this.center.y,
        this.center.x, this.center.y - this.radius - this.pointerLength
      );
      pointerGradient.addColorStop(0, 'rgba(37, 99, 235, 0.8)');
      pointerGradient.addColorStop(1, 'rgba(37, 99, 235, 1)');

      ctx.beginPath();
      ctx.moveTo(this.center.x, this.center.y);
      ctx.lineTo(this.center.x, this.center.y - this.radius - this.pointerLength);
      ctx.strokeStyle = pointerGradient;
      ctx.lineWidth = this.pointerLineWidth;
      ctx.lineCap = 'round';
      ctx.stroke();

      // 在指针顶端添加一个现代化的三角形标记
      const triangleSize = 10 * this.scaleFactor;
      const triangleOffset = 18 * this.scaleFactor;

      // 三角形阴影
      ctx.beginPath();
      ctx.moveTo(this.center.x + 1, this.center.y - this.radius - this.pointerLength + 1);
      ctx.lineTo(this.center.x - triangleSize + 1, this.center.y - this.radius - this.pointerLength - triangleOffset + 1);
      ctx.lineTo(this.center.x + triangleSize + 1, this.center.y - this.radius - this.pointerLength - triangleOffset + 1);
      ctx.closePath();
      ctx.fillStyle = 'rgba(0, 0, 0, 0.2)';
      ctx.fill();

      // 三角形主体
      ctx.beginPath();
      ctx.moveTo(this.center.x, this.center.y - this.radius - this.pointerLength);
      ctx.lineTo(this.center.x - triangleSize, this.center.y - this.radius - this.pointerLength - triangleOffset);
      ctx.lineTo(this.center.x + triangleSize, this.center.y - this.radius - this.pointerLength - triangleOffset);
      ctx.closePath();

      const triangleGradient = ctx.createLinearGradient(
        this.center.x, this.center.y - this.radius - this.pointerLength,
        this.center.x, this.center.y - this.radius - this.pointerLength - triangleOffset
      );
      triangleGradient.addColorStop(0, '#2563EB');
      triangleGradient.addColorStop(1, '#1D4ED8');

      ctx.fillStyle = triangleGradient;
      ctx.fill();

      // 三角形边框
      ctx.strokeStyle = 'rgba(255, 255, 255, 0.3)';
      ctx.lineWidth = 1;
      ctx.stroke();

      // 如果指针在数据弧线范围内，在数据弧线上标记当前位置
      if (this.currentPointerValue) {
        const pointerX = this.center.x + Math.cos(this.pointerAngle) * this.radius;
        const pointerY = this.center.y + Math.sin(this.pointerAngle) * this.radius;
        const markerRadius = 10 * this.scaleFactor;

        // 外圈发光效果
        ctx.beginPath();
        ctx.arc(pointerX, pointerY, markerRadius + 4, 0, Math.PI * 2);
        ctx.fillStyle = 'rgba(37, 99, 235, 0.2)';
        ctx.fill();

        // 中圈
        ctx.beginPath();
        ctx.arc(pointerX, pointerY, markerRadius + 2, 0, Math.PI * 2);
        ctx.fillStyle = 'rgba(37, 99, 235, 0.4)';
        ctx.fill();

        // 主标记圆圈
        ctx.beginPath();
        ctx.arc(pointerX, pointerY, markerRadius, 0, Math.PI * 2);
        ctx.fillStyle = '#ffffff';
        ctx.fill();

        // 边框
        ctx.strokeStyle = '#2563EB';
        ctx.lineWidth = Math.max(2, 3 * this.scaleFactor);
        ctx.stroke();

        // 内圈装饰
        ctx.beginPath();
        ctx.arc(pointerX, pointerY, markerRadius - 3, 0, Math.PI * 2);
        ctx.fillStyle = '#2563EB';
        ctx.fill();
      }

      ctx.restore();
    },

    // 绘制时间文本（10分钟为一个间隔，不显示刻度线）
    drawTimeScale(ctx) {
      if (!this.list || this.list.length === 0) {
        return;
      }

      ctx.save();

      // 获取数据的时间范围
      const firstTime = new Date(this.list[0].receivedTime);
      const lastTime = new Date(this.list[this.list.length - 1].receivedTime);
      const totalTimeSpan = Math.abs((lastTime - firstTime) / 1000); // 总时间跨度（秒）

      // 10分钟 = 600秒
      const scaleInterval = 600; // 10分钟间隔
      const scaleCount = Math.ceil(totalTimeSpan / scaleInterval);

      // 计算每个刻度在弧线上的角度间隔
      const anglePerScale = this.dataArcLength / (totalTimeSpan / scaleInterval);

      // 只绘制时间标签，不绘制刻度线
      for (let i = 0; i <= scaleCount; i++) {
        // 计算当前刻度的角度位置
        const scaleAngle = this.dataStartAngle + (i * anglePerScale);

        // 如果刻度超出了数据弧线范围，跳过
        if (i * anglePerScale > this.dataArcLength) {
          break;
        }

        // 计算对应的时间
        const scaleTime = new Date(firstTime.getTime() + (i * scaleInterval * 1000));
        const timeLabel = scaleTime.toLocaleTimeString('zh-CN', {
          hour: '2-digit',
          minute: '2-digit',
          hour12: false
        });

        // 绘制时间标签（横放显示）- 现代化样式
        // 标签位置在弧线外侧
        const labelRadius = this.radius + 30 * this.scaleFactor;
        const labelX = this.center.x + Math.cos(scaleAngle) * labelRadius;
        const labelY = this.center.y + Math.sin(scaleAngle) * labelRadius;

        // 绘制标签背景
        const padding = 6 * this.scaleFactor;
        const fontSize = Math.max(10, 11 * this.scaleFactor);
        ctx.font = `${fontSize}px -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif`;

        const textMetrics = ctx.measureText(timeLabel);
        const textWidth = textMetrics.width;
        const textHeight = fontSize;

        // 背景圆角矩形
        ctx.fillStyle = 'rgba(255, 255, 255, 0.9)';
        ctx.beginPath();
        ctx.roundRect(
          labelX - textWidth/2 - padding,
          labelY - textHeight/2 - padding/2,
          textWidth + padding * 2,
          textHeight + padding,
          4 * this.scaleFactor
        );
        ctx.fill();

        // 背景边框
        ctx.strokeStyle = 'rgba(59, 130, 246, 0.2)';
        ctx.lineWidth = 1;
        ctx.stroke();

        // 时间文本
        ctx.fillStyle = '#374151';
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';
        ctx.fillText(timeLabel, labelX, labelY);
      }

      ctx.restore();
    },

    // 绘制多彩数据弧线 - 基于状态的颜色
    drawDataArc(ctx) {
      // 首先检查list是否为空
      if (!this.list || this.list.length === 0) {
        console.log('list数据为空，跳过绘制数据弧线');
        return;
      }

      if (this.dataValues.length === 0) {
        console.log('没有数据值，跳过绘制');
        return;
      }

      ctx.save();
      ctx.lineWidth = this.dataArcLineWidth; // 使用响应式线宽
      ctx.lineCap = 'round'; // 设置线条端点样式为圆角，更现代
      ctx.shadowBlur = 3 * this.scaleFactor; // 添加阴影效果

      // 按状态分组，将相邻的相同状态合并为连续段
      const statusSegments = [];
      let currentSegment = null;

      for (let i = 0; i < this.dataValues.length; i++) {
        const dataObj = this.dataValues[i];

        if (!currentSegment || currentSegment.colorType !== dataObj.colorType) {
          // 开始新的段
          if (currentSegment) {
            statusSegments.push(currentSegment);
          }
          currentSegment = {
            start: i,
            end: i,
            colorType: dataObj.colorType,
            status: dataObj.status,
            values: [dataObj.value]
          };
        } else {
          // 继续当前段
          currentSegment.end = i;
          currentSegment.values.push(dataObj.value);
        }
      }

      // 添加最后一个段
      if (currentSegment) {
        statusSegments.push(currentSegment);
      }

      console.log('状态段数量:', statusSegments.length);

      // 绘制每个状态段
      statusSegments.forEach((segment) => {
        // 计算该段的起始和结束角度
        const segmentStartAngle = this.dataStartAngle + segment.start * this.segmentAngle;
        const segmentEndAngle = this.dataStartAngle + (segment.end + 1) * this.segmentAngle;

        // 计算该段的平均数据值来确定透明度
        const avgValue = segment.values.reduce((sum, val) => sum + val, 0) / segment.values.length;
        const intensity = avgValue / 100;
        const alpha = 0.6 + intensity * 0.4; // 调整透明度范围，使其更明显

        // 根据状态设置颜色 - 使用现代化的颜色方案
        let strokeStyle;
        ctx.shadowColor = 'rgba(0, 0, 0, 0.1)';

        switch (segment.colorType) {
          case 'red':     // running 跑
            strokeStyle = `rgba(239, 68, 68, ${alpha})`; // 现代红色
            ctx.shadowColor = 'rgba(239, 68, 68, 0.3)';
            break;
          case 'yellow':  // sitting 坐
            strokeStyle = `rgba(245, 158, 11, ${alpha})`; // 现代橙黄色
            ctx.shadowColor = 'rgba(245, 158, 11, 0.3)';
            break;
          case 'green':   // standing 站立
            strokeStyle = `rgba(34, 197, 94, ${alpha})`; // 现代绿色
            ctx.shadowColor = 'rgba(34, 197, 94, 0.3)';
            break;
          case 'purple':  // walking 行走
            strokeStyle = `rgba(147, 51, 234, ${alpha})`; // 现代紫色
            ctx.shadowColor = 'rgba(147, 51, 234, 0.3)';
            break;
          case 'blue':    // lying 爬
            strokeStyle = `rgba(59, 130, 246, ${alpha})`; // 现代蓝色
            ctx.shadowColor = 'rgba(59, 130, 246, 0.3)';
            break;
          case 'gray':    // eatting 吃
            strokeStyle = `rgba(107, 114, 128, ${alpha})`; // 现代灰色
            ctx.shadowColor = 'rgba(107, 114, 128, 0.3)';
            break;
          default:
            strokeStyle = `rgba(239, 68, 68, ${alpha})`;
            ctx.shadowColor = 'rgba(239, 68, 68, 0.3)';
        }

        ctx.strokeStyle = strokeStyle;

        // 绘制整个状态段作为一个连续的弧线
        ctx.beginPath();
        ctx.arc(this.center.x, this.center.y, this.radius, segmentStartAngle, segmentEndAngle, false);
        ctx.stroke();
      });

      ctx.restore();
    },

    // 获取状态的中文文本
    getStatusText(status) {
      const statusTextMap = {
        'running': '跑',
        'sitting': '坐',
        'standing': '站立',
        'walking': '行走',
        'lying': '爬',
        'eatting': '吃'
      };
      return statusTextMap[status] || status;
    },

    // 获取状态对应的颜色 - 使用现代化颜色
    getStatusColor(status) {
      const statusColorMap = {
        'running': '#EF4444',    // 跑 - 现代红色
        'sitting': '#F59E0B',    // 坐 - 现代橙黄色
        'standing': '#22C55E',   // 站立 - 现代绿色
        'walking': '#9333EA',    // 行走 - 现代紫色
        'lying': '#3B82F6',      // 爬 - 现代蓝色
        'eatting': '#6B7280'     // 吃 - 现代灰色
      };
      return statusColorMap[status] || '#EF4444';
    }
  }
}
</script>

<style scoped>
.time-component {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 1rem;
}

.canvas-container {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  /* background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
  box-shadow:
    0 10px 25px rgba(0, 0, 0, 0.1),
    inset 0 1px 0 rgba(255, 255, 255, 0.6); */
  padding: 1rem;
  transition: all 0.3s ease;
}

.canvas-container:hover {
  transform: scale(1.02);
  box-shadow:
    0 15px 35px rgba(0, 0, 0, 0.15),
    inset 0 1px 0 rgba(255, 255, 255, 0.6);
}

.time-canvas {
  touch-action: none;
  border-radius: 50%;
  cursor: grab;
  transition: all 0.2s ease;
}

.time-canvas:active {
  cursor: grabbing;
  transform: scale(0.98);
}

/* 添加一些装饰性元素 */
.canvas-container::before {
  content: '';
  position: absolute;
  top: -2px;
  left: -2px;
  right: -2px;
  bottom: -2px;
  background: linear-gradient(45deg,
    var(--primary-color, #3B82F6) 0%,
    var(--secondary-color, #93C5FD) 25%,
    var(--accent-color, #2563EB) 50%,
    var(--primary-light, #60A5FA) 75%,
    var(--primary-color, #3B82F6) 100%);
  border-radius: 50%;
  z-index: -1;
  opacity: 0.1;
  animation: rotate 10s linear infinite;
}

@keyframes rotate {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

/* 响应式设计 */
@media (max-width: 768px) {
  .time-component {
    padding: 0.75rem;
  }

  .canvas-container {
    padding: 0.75rem;
  }

  .canvas-container:hover {
    transform: none; /* 移动端禁用hover效果 */
  }
}

/* 深色模式支持 */
@media (prefers-color-scheme: dark) {
  .canvas-container {
    background: linear-gradient(135deg, #1e293b 0%, #334155 100%);
    box-shadow:
      0 10px 25px rgba(0, 0, 0, 0.3),
      inset 0 1px 0 rgba(255, 255, 255, 0.1);
  }

  .canvas-container:hover {
    box-shadow:
      0 15px 35px rgba(0, 0, 0, 0.4),
      inset 0 1px 0 rgba(255, 255, 255, 0.1);
  }
}
</style>